export default __webpack_public_path__ + "static/goods-campaign-1-4c5ea706d8f8e0ffabddb236d10dfcba.png";